/**
 * Solio Product Hero
 *  - Thumb rail click → swap active hero image (data-active toggle on <li>).
 *  - Variant pack-card selection → update hidden form id, price, per-bottle
 *    hint, sticky URL ?variant= param.
 *
 *  No format selector, no dot pagination, no sticky mobile bar, no live
 *  viewers — those have been removed from the rebuilt PDP.
 */
(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-solio-product-hero]');
  if (!roots.length) return;

  roots.forEach(function (root) { init(root); });

  function init(root) {
    var variantInput   = root.querySelector('[data-variant-id]');
    var variantPills   = root.querySelectorAll('[data-variant-pill]');
    var priceEl        = root.querySelector('[data-price]');
    var perBottleHint  = root.querySelector('[data-per-bottle-hint]');
    var atc            = root.querySelector('[data-atc]');
    var atcLabel       = root.querySelector('[data-atc-label]');
    var thumbButtons   = root.querySelectorAll('[data-thumb-btn]');
    var mediaItems     = root.querySelectorAll('.solio-product-hero__media');
    var mediaAdvance   = root.querySelector('[data-media-advance]');
    var stickyBar      = root.querySelector('[data-sticky-bar]');
    var stickyVariant  = root.querySelector('[data-sticky-variant]');
    var stickyPrice    = root.querySelector('[data-sticky-price]');
    var stickyCta      = root.querySelector('[data-sticky-cta]');
    var activeIndex    = 0;

    /* ---- variant (pack-card) selection ---- */
    variantPills.forEach(function (pill) {
      if (pill.getAttribute('aria-disabled') === 'true') return;

      pill.addEventListener('click', function () {
        var variantId    = pill.dataset.variantId;
        var priceFmt     = pill.dataset.variantPriceFormatted;
        var available    = pill.dataset.variantAvailable === 'true';
        var qty          = parseInt(pill.dataset.variantQty, 10) || 1;
        var perBottleFmt = pill.dataset.variantPerBottle;

        if (variantInput) variantInput.value = variantId;
        if (priceEl)      priceEl.textContent = priceFmt;

        if (perBottleHint) {
          if (qty > 1) {
            var tpl = perBottleHint.dataset.template || 'pro Flasche';
            perBottleHint.textContent = perBottleFmt + ' ' + tpl;
            perBottleHint.removeAttribute('hidden');
          } else {
            perBottleHint.textContent = '';
            perBottleHint.setAttribute('hidden', '');
          }
        }

        if (atc && atcLabel) {
          if (available) {
            var lbl = atcLabel.dataset.labelDefault || atcLabel.textContent;
            atcLabel.textContent = lbl;
            atc.disabled = false;
            atc.removeAttribute('aria-disabled');
          } else {
            atc.disabled = true;
            atc.setAttribute('aria-disabled', 'true');
          }
        }

        /* Mirror variant state in the mobile sticky bar. */
        if (stickyVariant) stickyVariant.textContent = pill.dataset.variantTitle || '';
        if (stickyPrice)   stickyPrice.textContent   = priceFmt;
        if (stickyCta && stickyCta.type === 'submit') {
          stickyCta.disabled = !available;
          if (available) stickyCta.removeAttribute('aria-disabled');
          else           stickyCta.setAttribute('aria-disabled', 'true');
        }

        variantPills.forEach(function (p) {
          var match = p === pill;
          p.classList.toggle('is-selected', match);
          p.setAttribute('aria-checked', match ? 'true' : 'false');
        });

        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url);
        } catch (e) {}
      });
    });

    /* ---- gallery: thumb rail + tap-to-advance on the hero image ---- */
    function setActiveSlide(idx) {
      activeIndex = idx;
      if (mediaItems.length) {
        mediaItems.forEach(function (li, i) {
          li.setAttribute('data-active', i === idx ? 'true' : 'false');
        });
      }
      if (thumbButtons.length) {
        thumbButtons.forEach(function (b, i) {
          b.classList.toggle('is-active', i === idx);
        });
        // Keep the active thumb visible in the horizontal scroll rail.
        var activeThumb = thumbButtons[idx];
        if (activeThumb && typeof activeThumb.scrollIntoView === 'function') {
          activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
    }

    setActiveSlide(0);

    thumbButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.dataset.thumbIndex, 10) || 0;
        setActiveSlide(idx);
      });
    });

    if (mediaAdvance && mediaItems.length > 1) {
      mediaAdvance.addEventListener('click', function () {
        var next = (activeIndex + 1) % mediaItems.length;
        setActiveSlide(next);
      });
    }

    /* ---- sticky bar visibility ----
       Show once the in-page CTA (or, if drop is closed, the closed-state
       CTA button) scrolls out of view. IntersectionObserver with a
       generous bottom rootMargin so we wait until the user has fully
       passed the buy box before pinning the bar. */
    if (stickyBar) {
      var watchTarget = atc || root.querySelector('[data-waitlist-trigger]');
      if (watchTarget && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            stickyBar.classList.toggle('is-visible', show);
            stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
            if (show) stickyBar.removeAttribute('hidden');
          });
        }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
        io.observe(watchTarget);
      } else {
        /* Fallback: just show it on any scroll past 600px. */
        var onScroll = function () {
          var show = window.scrollY > 600;
          stickyBar.classList.toggle('is-visible', show);
          if (show) stickyBar.removeAttribute('hidden');
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
    }
  }
})();
